// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface ClassroomImageUpload
 */
export interface ClassroomImageUpload {
    /**
     * 
     * @type {string}
     * @memberof ClassroomImageUpload
     */
    imageUrl: string;
}

export function ClassroomImageUploadFromJSON(json: any): ClassroomImageUpload {
    return {
        'imageUrl': json['image_url'],
    };
}

export function ClassroomImageUploadToJSON(value?: ClassroomImageUpload): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'image_url': value.imageUrl,
    };
}


